// components/GuestFilterBar.jsx
import React from 'react';
import { Search, Filter } from 'lucide-react';

export const GuestFilterBar = ({
  guests,
  searchTerm,
  setSearchTerm,
  selectedTagFilter,
  setSelectedTagFilter,
  allTags,
  rsvpFilters = [],
  selectedRsvpFilter,
  setSelectedRsvpFilter,
}) => {
  return (
    <div className="space-y-4 p-4 md:p-6 md:px-8">
      <div className="flex flex-col gap-4 md:flex-row">
        <div className="flex-1 relative">
          <Search className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
          <input
            type="text"
            value={searchTerm}
            onChange={e => setSearchTerm(e.target.value)}
            placeholder="Search guests..."
            className="w-full pl-12 pr-4 py-4 bg-gray-50 rounded-3xl border-none outline-none font-bold"
          />
        </div>
        <div className="flex items-center gap-2 bg-gray-50 p-2 rounded-3xl border border-gray-100">
          <Filter size={16} className="text-gray-400 ml-2" />
          <select
            value={selectedTagFilter}
            onChange={e => setSelectedTagFilter(e.target.value)}
            className="bg-transparent text-xs font-black uppercase outline-none pr-4"
          >
            {allTags.map(tag => (
              <option key={tag.id} value={tag.name}>{tag.name}</option>
            ))}
          </select>
        </div>
      </div>

      {rsvpFilters.length > 0 && (
        <div className="flex gap-2 overflow-x-auto pb-1">
          {rsvpFilters.map((filter) => {
            const isActive = selectedRsvpFilter === filter.id;
            return (
              <button
                key={filter.id}
                type="button"
                onClick={() => setSelectedRsvpFilter(filter.id)}
                className={`shrink-0 rounded-full px-4 py-2 text-[10px] font-black uppercase tracking-[0.16em] transition ${
                  isActive
                    ? "bg-gray-950 text-white shadow-lg"
                    : "bg-gray-50 text-gray-500 hover:bg-[#fff1f8] hover:text-[#ff0099]"
                }`}
              >
                {filter.label}
                <span className={`ml-2 ${isActive ? "text-white/70" : "text-gray-400"}`}>
                  {filter.count}
                </span>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};
